import { useEffect, useState} from "react"

const keys = { ArrowUp: "forward", ArrowDown: "backward", ArrowLeft: "left", ArrowRight: "right", KeyA : "left", KeyD : "right", KeyW : "forward", KeyS : "backward"}
const moveFieldByKey = (key) => keys[key]

const usePlayerControls = () => {
  const [movement, setMovement] = useState({ forward: false, backward: false, left: false, right: false, up : false, down : false})
  const [move, setMove] = useState(true)

  useEffect(() => {

    const fields = document.querySelectorAll('input')
    fields.forEach(f => {
      f.addEventListener('focusin', () => {
        setMove(false)
      })

      f.addEventListener('focusout', () => {
        setMove(true)
      })
    })

    const handleKeyDown = (e) => move === true ? setMovement((m) => ({ ...m, [moveFieldByKey(e.code)]: true })) : null
    const handleKeyUp = (e) => setMovement((m) => ({ ...m, [moveFieldByKey(e.code)]: false }))
    document.addEventListener("keydown", handleKeyDown)
    document.addEventListener("keyup", handleKeyUp)

    return () => {
      document.removeEventListener("keydown", handleKeyDown)
      document.removeEventListener("keyup", handleKeyUp)
    }
  }, [move])
  return movement
}

export default usePlayerControls